import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./basket-navigation.module.css";
import { useContext, useState, useEffect } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { TimeIcon } from "../../../assets/time";
import cx from "classnames";
import { useExpiry } from "../../hooks/use-expiry";
import { BasketComponent } from "./basket-component";
import { BasketIconWrapper } from "./basket-icon-wrapper";
export var BasketNavigation = function(param) {
    var checkoutModalAvailable = param.checkoutModalAvailable, shouldShowBasketIcon = param.shouldShowBasketIcon;
    var ref = useContext(SharedUiHeaderV2Context), userStore = ref.userStore, logicStore = ref.logicStore;
    var ref1 = useState(false), isInCheckoutJourney = ref1[0], setIsInCheckoutJourney = ref1[1];
    var ref2 = useState(false), shouldShowExpiringOrExpired = ref2[0], setShouldShowExpiringOrExpired = ref2[1];
    var isLoggedIn = userStore.isLoggedIn, activeOrder = userStore.activeOrder, refreshActiveOrder = userStore.refreshActiveOrder;
    var isCheckoutModalVisible = logicStore.isCheckoutModalVisible, setIsCheckoutModalVisible = logicStore.setIsCheckoutModalVisible;
    /* Times needed to calculate which icon to show*/ var warningTime = 5 * 60 * 1000;
    var timeNow = Math.floor(Date.now());
    var ref3;
    var orderHasExpired = ((ref3 = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) !== null && ref3 !== void 0 ? ref3 : 0) < timeNow;
    var isExpiringSoon = (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) ? warningTime + timeNow > (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) : null;
    useEffect(function() {
        if ("object" !== "undefined") {
            var pathname = window.location.pathname;
            var regex = /checkout/;
            setIsInCheckoutJourney(regex.test(pathname));
            /* This needs to wrap the refreshActiveOrder to
       * ensure we wait for the activeOrder to be populated
       */ var refreshActiveOrderData = function() {
                var _ref = _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isLoggedIn) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    refreshActiveOrder()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function refreshActiveOrderData() {
                    return _ref.apply(this, arguments);
                };
            }();
            refreshActiveOrderData();
        }
    }, [
        isLoggedIn
    ]);
    useExpiry(activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt, setShouldShowExpiringOrExpired, timeNow, warningTime, !!(orderHasExpired || isExpiringSoon));
    var isBasketVisible = isLoggedIn && (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) && shouldShowBasketIcon && isInCheckoutJourney === false;
    var isExpiringOrExpiredBasket = isBasketVisible && shouldShowExpiringOrExpired === true;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isExpiringOrExpiredBasket && /*#__PURE__*/ _jsx(BasketComponent, {
                tag: checkoutModalAvailable === true ? "button" : "a",
                setShouldShowCheckoutModal: function() {
                    setIsCheckoutModalVisible && setIsCheckoutModalVisible(!isCheckoutModalVisible);
                },
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: cx(styles.timerIcon, styles.pulse),
                            children: /*#__PURE__*/ _jsx(TimeIcon, {})
                        }),
                        /*#__PURE__*/ _jsx(BasketIconWrapper, {})
                    ]
                })
            }),
            isBasketVisible && !isExpiringOrExpiredBasket && /*#__PURE__*/ _jsx(BasketComponent, {
                tag: checkoutModalAvailable === true ? "button" : "a",
                setShouldShowCheckoutModal: function() {
                    setIsCheckoutModalVisible && setIsCheckoutModalVisible(!isCheckoutModalVisible);
                },
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: styles.number,
                            children: "1"
                        }),
                        /*#__PURE__*/ _jsx(BasketIconWrapper, {})
                    ]
                })
            })
        ]
    });
};
